/* eslint-disable */

let blockedIp = null;
const listeners = new Set();

export function setIpBlocked(ip) {
  blockedIp = ip || null;
  listeners.forEach(fn => fn(blockedIp));
}

export function getIpBlocked() {
  return blockedIp;
}

export function subscribeIpBlocked(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function parseIpBlockedFromResponse(status, data) {
  if (status === 403 && data && data.error === 'IP_BLOCKED') {
    return data.ip || '';
  }
  return null;
}
